export const FIVE_PERCENT_DISCOUNT_SETTINGS = {
  id: 'customerDiscount',
  type: 'percentage',
  value: 5
};
